import _ from "lodash";

export const WANT_LISTING_STATUSES = [
  { key: "draft", label: "Draft" },
  { key: "active", label: "Active" },
  { key: "under_contract", label: "Under Contract" },
  { key: "closed", label: "Closed" },
  { key: "withdrawn", label: "Archived" },
  { key: "expired", label: "Expired" },
];

const LABELS = WANT_LISTING_STATUSES.reduce(
  (acc, status) => ({ ...acc, [status.key]: status.label }),
  {}
);

const CODES = {
  DRAFT: "draft",
  ACTIVE: "active",
  PUBLISHED: "active",
  PENDING: "under_contract",
  PENDING_WITH_CONTIGENCIES: "under_contract",
  UNDER_CONTRACT: "under_contract",
  CLOSED: "closed",
  TERMINATED: "withdrawn",
  ARCHIVED: "withdrawn",
  WITHDRAWN: "withdrawn",
  EXPIRED: "expired",
};

const isOn = (ad, key) => Number(_.get(ad, key, 0)) === 1;

export const deriveWantListingStatus = (ad) => {
  if (isOn(ad, "IsClosed")) return "closed";
  if (isOn(ad, "IsTerminated")) return "withdrawn";
  if (isOn(ad, "IsArchived"))
    return isOn(ad, "IsAutoArchived") ? "expired" : "withdrawn";
  if (isOn(ad, "IsPending") || isOn(ad, "IsPendingWithContigencies"))
    return "under_contract";
  return isOn(ad, "IsPublished") ? "active" : "draft";
};

export const clientFormStatus = (ad) => {
  if (!isOn(ad, "IsFilledByClient") || isOn(ad, "IsPublished")) return null;
  return isOn(ad, "IsReadyToReview") ? "Ready to review" : "With your client";
};

export const wantListingStatusKey = (value) => {
  if (!value) return null;
  const text = String(value).trim();
  if (LABELS[text]) return text;
  return CODES[text.toUpperCase().replace(/[\s-]+/g, "_")] || null;
};

export const wantListingStatusLabel = (value) =>
  LABELS[wantListingStatusKey(value)] || "";
